import { useState } from "react";
import Hamburger from "hamburger-react";

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuList = {
    menus: [
      {
        num: "01",
        menu: "About",
        link: "#about",
        scroll: "about",
      },
      {
        num: "02",
        menu: "Skill",
        link: "#skill",
        scroll: "skill",
      },
      {
        num: "03",
        menu: "Education",
        link: "#edu",
        scroll: "edu",
      },
      {
        num: "04",
        menu: "Project",
        link: "#project",
        scroll: "project",
      },
    ],
  };
  const scrollToEl = (e, scroll) => {
    e.preventDefault();
    document.getElementById(scroll).scrollIntoView({ behavior: "smooth" });
    setIsOpen((prev) => !prev);
    document.body.classList.remove("lock");
  };
  return (
    <div>
      <div className="block md:hidden z-50 relative">
        <Hamburger
          toggled={isOpen}
          toggle={setIsOpen}
          onToggle={(toggled) => {
            if (toggled) {
              // open a menu
              document.body.classList.add("lock");
            } else {
              // close a menu
              document.body.classList.remove("lock");
            }
          }}
        />
      </div>

      <nav
        className={
          (isOpen ? "open right-0 " : "-right-full ") +
          "w-10/12 h-screen absolute top-0 bottom-0 pt-[124px] bg-[#0f229b] z-40 flex duration-300 md:w-auto md:h-auto md:static md:pt-0 md:bg-inherit"
        }
      >
        <ul className="w-full flex flex-col justify-center md:flex-row md:w-auto">
          {menuList.menus.map((menu) => (
            <li key={menu.num} className="ml-0 mb-3 md:ml-8 md:mb-0">
              <a
                href={menu.link}
                className="pt-mono text-center py-2 px-4 flex flex-col  hover:text-blue-400 hover:font-bold md:p-0 md:block"
                onClick={(e) => scrollToEl(e, menu.scroll)}
              >
                <span className="font-bold text-blue-400">{menu.num}.</span>
                <span className="hidden md:inline-block">&nbsp;</span>
                <span>{menu.menu}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Nav;
